import { render, staticRenderFns } from "./addDeboursComponent.vue?vue&type=template&id=f870622a"
import script from "./addDeboursComponent.vue?vue&type=script&lang=js"
export * from "./addDeboursComponent.vue?vue&type=script&lang=js"
import style0 from "./addDeboursComponent.vue?vue&type=style&index=0&id=f870622a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports